import { Controller } from "stimulus"

export default class extends Controller {
  connect() {
    const event = new CustomEvent('search:results-loaded');
    document.dispatchEvent(event);
  }
}
